// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as NewsletterRouteImport } from './routes/newsletter'
import { Route as HeadlineRouteImport } from './routes/headline'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AssessmentRouteImport } from './routes/assessment'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FSlugRouteImport } from './routes/f.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const ScanRoute = ScanRouteImport.update({
            id: '/scan',path: '/scan',getParentRoute: () => rootRouteImport
          })
const NewsletterRoute = NewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => rootRouteImport
          })
const HeadlineRoute = HeadlineRouteImport.update({
            id: '/headline',path: '/headline',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AssessmentRoute = AssessmentRouteImport.update({
            id: '/assessment',path: '/assessment',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const FSlugRoute = FSlugRouteImport.update({
            id: '/f/$slug',path: '/f/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AssessmentRoute: AssessmentRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,HeadlineRoute: HeadlineRoute,NewsletterRoute: NewsletterRoute,ScanRoute: ScanRoute,FSlugRoute: FSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)